import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { HelpdeskService } from "./../services/helpdesk/helpdesk.service";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Observable } from "rxjs";
import swal from "sweetalert2";
import { environment } from "../../environments/environment";
import { ProjectsService } from "../services/projects/projects.service";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { Ticket } from "../models/ticket";
import { e } from "@angular/core/src/render3";

@Component({
  selector: "app-add-ticket",
  templateUrl: "./add-ticket.component.html",
  styleUrls: ["./add-ticket.component.scss"],
})
export class AddTicketComponent implements OnInit {
  addTicketForm: FormGroup;
  ticket_sources: any;
  ticket_priorities: any;
  ticket_types: any;
  selectableLeads = [];
  dataFromSearch: any = [];
  attachments: any = [];
  reservations: any = [];
  disable_submit_btn: any;
  ticketToBeEdited: Ticket;
  isEditMode: boolean = false;
  private searchBy: "lead" | "rfid" | "unit_serial" = "lead";
  set searchMode(val: number) {
    if (val == 0) this.searchBy = "lead";
    else if (val == 1) this.searchBy = "rfid";
    else if (val == 2) this.searchBy = "unit_serial";
  }
  get searchMode() {
    if (this.searchBy == "lead") return 0;
    if (this.searchBy == "rfid") return 1;
    if (this.searchBy == "unit_serial") return 2;
  }

  reservationsDropdownSettings: any = {
    singleSelection: false,
    idField: "id",
    textField: "id",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 100,
    allowSearchFilter: false,
  };

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private formBuilder: FormBuilder,
    private helpdeskService: HelpdeskService,
    public http: HttpClient,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getTicketTypes();
    this.getTicketSources();
    this.getTicketPriorities();

    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.helpdeskService.getTicketDetails(params.id).subscribe((ticket) => {
          this.isEditMode = true;
          this.ticketToBeEdited = ticket;
          this.ticketToBeEdited.reservations.map((r) => {
            r["selectLabel"] = `${r.id} - ${r.unit.serial}`;
          });
          this.createEditTicketForm();
          this.getTicketReservations(params.id);
        });
      } else this.createAddTicketForm();
    });
  }

  createEditTicketForm() {
    let reservations = this.ticketToBeEdited.reservations || [];
    // this.ticketToBeEdited.reservations.forEach(element => {
    //   reservations = element.id;
    // });
    const lead = this.ticketToBeEdited.lead;
    this.addTicketForm = this.formBuilder.group({
      description: [
        this.ticketToBeEdited.description || "",
        Validators.required,
      ],
      type_id: [this.ticketToBeEdited.type_id || "", Validators.required],
      priority_id: [
        this.ticketToBeEdited.priority_id || "",
        Validators.required,
      ],
      source_id: [this.ticketToBeEdited.source_id || "", Validators.required],
      lead_id: [this.ticketToBeEdited.lead_id, Validators.required],
      selected_lead: [
        lead ? `#${lead.id} - ${lead.name} / ${lead.phone}` : "",
        Validators.required,
      ],
      reservations: [reservations],
      customer_name: [
        (this.ticketToBeEdited.customer &&
          this.ticketToBeEdited.customer.name) ||
          "",
        Validators.required,
      ],
      customer_phone: [
        (this.ticketToBeEdited.customer &&
          this.ticketToBeEdited.customer.phone) ||
          "",
      ],
      customer_notes: [
        (this.ticketToBeEdited.customer &&
          this.ticketToBeEdited.customer.notes) ||
          "",
      ],
      attachments: [this.ticketToBeEdited.attachments || null],
    });
  }

  createAddTicketForm() {
    this.addTicketForm = this.formBuilder.group({
      description: ["", Validators.required],
      type_id: ["", Validators.required],
      priority_id: ["", Validators.required],
      source_id: ["", Validators.required],
      lead_id: [null, Validators.required],
      selected_lead: ["", Validators.required],
      reservations: [[]],
      customer_name: ["", Validators.required],
      customer_phone: [""],
      customer_notes: [""],
      attachments: [],
    });
  }

  getTicketReservations(ticket_id) {
    this.helpdeskService
      .getTicketReservations(ticket_id)
      .subscribe((res: any) => {
        console.log("reservations : ", res);
        this.reservations = res.reservations;
      });
  }

  selectableLeadsObservable = (keyword: any): Observable<any[]> => {
    if (keyword) {
      return this.helpdeskService
        .searchLeads(keyword, this.searchBy)
        .map((res: any) => {
          this.dataFromSearch = res.data;
          return res.data.map((e) => `#${e.id} - ${e.name} / ${e.phone}`);
        });
    } else {
      return Observable.of([]);
    }
  };

  onLeadSelected(selectedLead: string) {
    if (!selectedLead) return;
    else if (!selectedLead.match(/#\d*/gim)) return;
    this.reservations = [];
    this.addTicketForm.get("reservations").patchValue([]);
    //Sorry
    const theLead: any = (this.dataFromSearch as []).filter(
      (e: any) =>
        e.id == ((selectedLead as string) || "").match(/#\d*/gim)[0].substr(1)
    )[0];
    console.log("The lead...", theLead);
    if (theLead) {
      this.addTicketForm.get("selected_lead").patchValue(selectedLead);
      this.reservations = theLead.reservations || [];
      this.addTicketForm.get("lead_id").patchValue(theLead.id || null);
      this.addTicketForm.get("customer_name").patchValue(theLead.name);
      this.addTicketForm.get("customer_phone").patchValue(theLead.phone);
    } else {
      this.addTicketForm.get("selected_lead").patchValue(selectedLead);
      this.reservations = [];
      this.addTicketForm.get("lead_id").patchValue(null);
    }
  }

  getTicketTypes() {
    this.helpdeskService.getTicketTypes().subscribe((res: any) => {
      this.ticket_types = res;
    });
  }

  getTicketPriorities() {
    this.helpdeskService.getTicketPriority().subscribe((res: any) => {
      this.ticket_priorities = res;
    });
  }

  getTicketSources() {
    this.helpdeskService.getTicketSource().subscribe((res: any) => {
      this.ticket_sources = res;
    });
  }

  addTicket() {
    let formVal = this.addTicketForm.value;
    let payload = {
      description: formVal.description,
      type_id: formVal.type_id,
      priority_id: formVal.priority_id,
      source_id: formVal.source_id,
      lead_id: formVal.lead_id,
      reservation_id: formVal.reservation_id,
      attachments: this.attachments,
      reservations: this.reservations.map((e) => e.id),
      customer: {
        name: formVal.customer_name,
        phone: formVal.customer_phone,
        notes: formVal.customer_notes,
      },
    };
    console.log(payload);
    this.disable_submit_btn = true;
    this.slimLoadingBarService.start();
    this.modifyTicket(payload, this.isEditMode);
  }

  private modifyTicket(payload, isEdit: boolean) {
    const onSuccess = (res: any) => {
      this.disable_submit_btn = false;
      this.slimLoadingBarService.complete();
      swal(
        "Success",
        `${this.isEditMode ? "Updated" : "Added"} Ticket Successfully`,
        "success"
      );
      this.router.navigateByUrl("/pages/tickets");
    };

    const onErr = (err) => {
      this.disable_submit_btn = false;
      this.slimLoadingBarService.reset();
      this.errorHandlerService.handleErorr(err);
    };
    if (isEdit)
      this.helpdeskService
        .editTicket(payload, this.ticketToBeEdited.id)
        .subscribe(onSuccess, onErr);
    else this.helpdeskService.addTicket(payload).subscribe(onSuccess, onErr);
  }

  get leadId() {
    return this.addTicketForm.value.lead_id;
  }

  async onFileChange(event) {
    let selectedFiles = event.target.files;
    for (let i = 0; i < selectedFiles.length; i++) {
      let file = selectedFiles[i];
      let reader = new FileReader();
      await reader.readAsDataURL(file);
      reader.onload = async () => {
        let attach = {
          name: file.name,
          type: file.type,
          src: (reader.result as any as any).split(",")[1],
        };
        await this.attachments.push(attach);
      };
      console.log(this.attachments);
    }
  }

  viewLead() {
    this.helpdeskService.viewLead(this.leadId);
  }

  viewReservation(id) {
    this.helpdeskService.viewReservation(id);
  }

  unselectLead() {
    this.addTicketForm.get("lead_id").reset();
    this.addTicketForm.get("selected_lead").reset();
    this.addTicketForm.get("reservations").reset();
    this.reservations = [];
  }

  cancel() {
    this.router.navigateByUrl("/pages/tickets");
  }
}



// WEBPACK FOOTER //
// ./src/app/add-ticket/add-ticket.component.ts